<template>
  <div id="buypoints">
    <div class="inner">
      <el-row class="title" style="border-bottom:dashed 1px rgba(151,151,151,0.5);padding-bottom:8px;">
        <el-col :span="20">
          <div class="grid-content bg-purple-dark box-title">购买{{$store.state.name}}</div>
        </el-col>
        <el-col :span="4" style="text-align:right;height:40px;line-height:40px;">
          <div
            class="grid-content bg-purple-dark ft15"
            style="font-size: 13px;font-family: MicrosoftYaHei;color: #7A7A7A;"
          >
            <span>
              <router-link style="color:#7a7a7a;font-size:13px;" :to="{name:'Buypointsrecord'}">{{$store.state.name}}购买记录</router-link>
            </span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-col>
        <div class="" style="clear:both"></div>
      </el-row>
      <div v-show="step==1" class="g-box">
        <div class="inputbox">
          <input type="text" v-model="points" placeholder="请输入需要购买的积分值" />
        </div>
        <button class="theme-bg ft14"  @click="buypoint">下一步</button>
      </div>
      <transition name="fadein">
      <div class="paymoney" v-show="step==2">
        <div class="tittop">
          <p>购买{{$store.state.name}}：{{points}}{{$store.state.name}}</p>
            <p>
              支付金额：
              <span class="theme-col">￥{{moeny}}</span>
            </p>
            <p>支付方式：微信支付</p>
        </div>
        <el-row style="width:562px;    display: flex;
    margin: 0 auto; align-items: center;padding-bottom:80px">
          <!-- <el-col :span="9">
            <p>购买{{$store.state.name}}：{{points}}{{$store.state.name}}</p>
            <p>
              支付金额：
              <span class="theme-col">￥{{moeny}}</span>
            </p>
            <p>支付方式：微信支付</p>
          </el-col> -->
          <el-col style="padding-right:57px;">
            <!-- <p style="width:198px;text-align:center">微信支付</p> -->
            <!-- <img :src="'http://'+url" alt="" style="width:198px;margin:10px 0 26px 0"> -->
            <canvas id="paycanvas" width="182px" style="width:182px;border: 1px solid #C7C7C7;"></canvas>
            <br />
            <div style="width: 182px;height: 48px;background: rgb(226, 49, 48);display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;">
              <img style="width:24px;height:24px;" src="/static/img/sm.png"><p style="color:#fff;font-size: 13px;line-height:17px;width:104px">请使用微信扫一扫
扫描二维码支付</p>
            </div>
            <!-- <img src="/static/img/scan.png" alt style="width:182px;margin-top:10px;" /> -->
          </el-col>
          <el-col >
            <img style="width:320px;" src="/static/img/phone.png" alt />
          </el-col>
        </el-row>
      </div>
      </transition>
      <transition name="fadein">
      <div class="buysuccess" v-show="step==3">
        <div class="" style="padding-top:90px;text-align:center;margin-bottom:14px;"><img src="/static/img/sucess.png"  style="width:44px;" /></div>
        <p style="margin-bottom:18px;height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;">
          恭喜您，{{$store.state.name}}购买成功！
        </p>
        <div class="box-info">
                  <p style="">支付单号：{{orderid}}</p>
        <p>购买{{$store.state.name}}：{{points}}{{$store.state.name}}</p>
        <p>
          支付金额：
          <span class="theme-col ft20">¥{{moeny}}</span>
        </p>
        <p>购买时间：{{time}}</p>
        </div>
        <div style="text-align:center;">
        <router-link :to="user/buypointsrecord" style="box-sizing:border-box;line-height:40px; display:inline-block;font-size: 16px;font-family: MicrosoftYaHei;color: #FFFFFF;width: 168px;height: 40px;background: #E23130;border-radius: 6px;border: 1px solid #E23130;">查看记录</router-link>
        </div>
      </div>
      </transition>
    </div>
  </div>
</template>
<script>
var QRCode = require('qrcode')
export default {
  data() {
    return {
      points: this.$route.params.points,
      step: 1,
      url: "",
      moeny: "",
      id: "",
      orderid: "",
      time: "",
      t: "",
      isshow: true
    };
  },
  watch: {
    points(val) {
      this.points = this.points.replace(/[^\d]+|(^0)+/g, "");
      // this.points = this.points.replace(/^0/,"")
    }
  },
  methods: {
    buypoint() {
      this.$api.get(
        "user/wechat/payPoint",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          point: this.points
        },
        res => {
          if (res.data.code == 100) {
            this.step = 2;
            this.id = res.data.data.pay_id;
            //   this.url=res.data.data.url
            this.moeny = res.data.data.amount;
            let str = res.data.data.url.split("php?text=");
            setTimeout(() => {
                var canvas = document.getElementById("paycanvas");
                QRCode.toCanvas(canvas, str[str.length - 1], function(error) {
                if (error) console.error(error);
                console.log("success!");
            });
            },200)
            clearInterval(this.t);
            this.t = setInterval(() => {
              this.payinfo();
            }, 1000);
            setTimeout(() => {
              clearInterval(this.t);
              this.$alert("二维码过期请重新购买", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  this.step = 1;
                }
              });
            }, 1800000);
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    payinfo() {
      this.$api.get(
        "user/wechat/buyinfo",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id: this.id
        },
        res => {
          if (res.data.data != null) {
            if (
              this.$route.params.points != "" &&
              this.$route.params.points != null &&
              this.$route.params.points != undefined
            ) {
              if (this.isshow) {
                this.isshow = false;
                this.$message({
                  message: "充值成功",
                  duration: 3000,
                  center: true
                });
              }
              if (
                this.$route.params.goodid != null &&
                this.$route.params.goodid != "" &&
                this.$route.params.goodid != undefined
              ) {
                this.$router.push({
                  name: "Detail",
                  params: { id: this.$route.params.goodid }
                });
              } else {
                this.$router.push({ name: "Cart" });
              }
            }
            this.step = 3;
            clearInterval(this.t);
            this.time = res.data.data.add_time;
            this.orderid = res.data.data.order_sn;
          }
        }
      );
    }
  },
  mounted() {
    this.step = 1;
    this.points = this.$route.params.points;
  },
  beforeDestroy() {
    clearInterval(this.t);
  }
};
</script>

<style lang="less" scoped>
.fadein-enter-active {
  transition: all 0.5s;
}
.fadein-leave-to {
  transition: all 0.5s;
}
// .fadein-transition {
//   transition: all .3s ease-in;
// 	height: 256px;
// 	opacity: 1;
// 	overflow: hidden;
// }
.fadein-enter{
  transform: translateX(-80%);
        opacity: 0;
  width: 0;
  height: 0;
  opacity: 0;
}
.fadein-leave-to {
  transform: translateX(110%);
  opacity: 0;
}
#buypoints {
  width: 985px;
  min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .box-title{
    height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;
  }
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
    overflow: hidden;
    .g-box{
      width: 262px;
      margin:0 auto;
      margin-top: 160px;
      button{
        margin-top: 20px;
        width: 100%;
        height: 48px;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;
      }
    }
    .inputbox {
      // margin: 50px 0px 26px 40px;
      // width: 240px;

      box-sizing: border-box;
      input {
        width: 100%;
        width: 100%;
      height: 52px;
      border: 1px solid #d6dee9;
      padding: 0 15px;
      box-sizing: border-box;
      &:hover{
        border:solid 1px #b8bfc9;
      }
      &:focus,&:active{
         border:solid 1px #E23130!important;
      }
      }
    }
    button {
      width: 109px;
      height: 36px;
      text-align: center;

    }
  }
  .paymoney {
    overflow: hidden;
     .tittop{
           display: flex;
    justify-content: space-between;
    height: 106px;
    background: #F7F7F7;
    align-items: center;
    box-sizing: border-box;
    padding: 0px 100px 0px 60px;
    margin-bottom: 30px;
    p{
      color:#535353;
    }
     }
    .el-col-9 {
      p {
        line-height: 32px;
        span {
          font-size: 20px;
        }
      }
    }
  }
  .buysuccess {
    width: 264px;
    position: relative;
    margin: 0 auto;
   .box-info{
    margin-bottom:20px;
p {
    text-align: center;
      // color: #353535;
       font-size: 13px;
font-family: MicrosoftYaHei;
color: #7A7A7A;
line-height: 28px;
    }
   }
    p {
    text-align: center;
      // color: #353535;
    }
    // p:first-child {
    //   padding-left: 0px;
    //   color: #000;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/buypoints.vue